"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piancastagnaio": {
    "d14e84ee": [{
      "hkey": "0ab7a651",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "0ab7a651",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piancastagnaio"
    }],
    "12c1ea81": [{
      "hkey": "0ab7a651",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-borgo": [{
      "hkey": "0ab7a651",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piancastagnaio"
    }],
    "42503bbf": [{
      "hkey": "0ab7a651",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "coro": [{
      "hkey": "0ab7a651",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piancastagnaio"
    }],
    "3706f2a5": [{
      "hkey": "90fc7aa4",
      "slug": "saragiolo",
      "name": "Saragiolo",
      "primary": true,
      "skipSearch": false
    }],
    "pietralunga": [{
      "hkey": "90fc7aa4",
      "slug": "saragiolo",
      "name": "Saragiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piancastagnaio"
    }],
    "0e9f5218": [{
      "hkey": "0ab7a651",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "voltaia": [{
      "hkey": "0ab7a651",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piancastagnaio"
    }]
  }
};
exports["default"] = _default;